<template>
    <div class="row mx-2 my-3 pricelist-settings">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    <h3>Locked Logins</h3>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    
                </div>
                <div class="col-sm-12 col-md-2 text-right">
                    
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th>Email</th>
                        <th>IP Address</th>
                        <th>Lock Type</th>
                        <th style="width: 10em"></th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-for="item in lockedUserLogins.data"
                        :key="item.id"
                    >
                        <tr>
                            <td>{{ item.email }}</td>
                            <td>{{ item.login_attempts }}</td>
                            <td>{{ item.lock_type }}</td>
                            <td>
                                <!-- <span
                                    class="px-1 view-action"
                                    @click="confirmModal(item)"
                                    ><i class="fa fa-trash" aria-hidden="true"></i>
                                    DELETE</span
                                > -->
                                <lock-unlock-button
                                  class="ml-2"
                                  :user="item.user"
                                  :current-user="user"
                                  @success="handleLockUnlockSuccess"
                                />
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <Bootstrap4Pagination
                :data="lockedUserLogins"
                @pagination-change-page="getResults"
                :align="'right'"
                :limit="1"
                :keepLength="true"
            >
                <template #prev-nav>
                    <i class="fa fa-arrow-left"></i> PREVIOUS</template
                >
                <template #next-nav>
                    NEXT <i class="fa fa-arrow-right"></i>
                </template>
            </Bootstrap4Pagination>

            <!-- Confirmation modal -->
            <b-modal v-model="modalShowConfirm" hide-footer>
                <Confirmation
                    v-if="modalShowConfirm"
                    :title="'Are you sure you want to delete this locked login?'"
                    @custom-func="deleteLockedLoginById"
                    @close-modal="closeModalConfirm"
                />
            </b-modal>
        </div>

    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Bootstrap4Pagination } from "laravel-vue-pagination";
import Confirmation from "@/components/Confirmation.vue";
import LockUnlockButton from "@/components/LockUnlockButton.vue";

export default {
    props: [],
    emits: [],
    components: {
        Bootstrap4Pagination,
        Confirmation,
        LockUnlockButton
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });

        function getAllLockedLogins() {
            store.dispatch("setting/getAllLockedLogins");
        }
        function updateLockedLogin(request) {
            store.dispatch("setting/updateLockedLogin", request);
        }

        const lockedUserLogins = computed(() => store.getters["setting/lockedUserLogins"]);

        onMounted(async () => {
          await store.dispatch('setting/getLockedUserLogins', {page: 1});
        });

        return {
            store,
            route,
            user,
            lockedUserLogins,
            getAllLockedLogins,
            updateLockedLogin
        };
    },
    data() {
        return {
            paginatedAllLockedLogins: [],
            currentPage: 1,
            modalShowConfirm: false,
            reqLockedLogin: {
                id: null
            }
        };
    },
    computed: {
        
    },
    methods: {
        async getResults(page = 1) {
          this.currentPage = page;

          await this.store.dispatch('setting/getLockedUserLogins', {page: page});
        },
        handleSearch() {
            if (this.debouncedFunction) {
                clearTimeout(this.debouncedFunction);
            }
            this.debouncedFunction = setTimeout(() => {
                this.getResults(1);
            }, 500);
        },
        confirmModal(item) {
            this.reqLockedLogin = {
                id: item.id,
                email: item.email
            };
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        deleteLockedLoginById() {
            this.store.dispatch("setting/deleteLockedLogin", this.reqLockedLogin).then((resp) => {
                this.getResults();
                window.emitter.emit("alertSuccess", {
                    message: "Locked Login deleted successfully!",
                });
            });
        },
        updateUserRoleSettings() {
            console.log(this.allUserRoles)

            this.updateUserRoleModules({
                user_role_modules: this.allUserRoles
            })
        },

        handleLockUnlockSuccess(user) {
          this.getResults(this.currentPage)
        }
    },
};
</script>
